export default "__VITE_ASSET__752efa74__"